import { useSyncExternalStore } from 'react';
import { getGenerationState, subscribeToGeneration } from './navigatorGenerationStore';
import type { NavigatorGenerationState } from './navigator-generation.types';

/**
 * Subscribes to a session's generation state. Snapshot identity is stable
 * between store emits (the store replaces the state object on patch), which is
 * what useSyncExternalStore needs to avoid render loops.
 */
export const useNavigatorGeneration = (
  sessionId?: string,
): NavigatorGenerationState | undefined =>
  useSyncExternalStore(subscribeToGeneration, () => getGenerationState(sessionId));
